export type { FloatingLabelProps } from './FloatingLabel'
export { FloatingLabel } from './FloatingLabel'
